module.exports = __webpack_public_path__ + "static/media/check-status.3ef81a72.svg";